<div class="spinner-container" *ngIf="isLoading">
  <div class="spinner"></div>
</div>
